import { render, staticRenderFns } from "./DettaglioDocumenti.vue?vue&type=template&id=eb49b976&"
import script from "./DettaglioDocumenti.vue?vue&type=script&lang=js&"
export * from "./DettaglioDocumenti.vue?vue&type=script&lang=js&"
import style0 from "./DettaglioDocumenti.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports